import "./ProfileAndHistoryZonePP.module.css";
import Header from "@/reusable_sections/Header";
import Profilsejarahhero from "./sections/Profilsejarahhero";
import OrganizationalProfile from "./sections/OrganizationalProfile";
import RelatedWartaNews from "./sections/RelatedWartaNews";
import Footer from "@/reusable_sections/Footer";
export default function ProfileAndHistoryZonePPPage() {
  return <div>
      <Header />
      <Profilsejarahhero />
      <OrganizationalProfile />
      <RelatedWartaNews />
      <Footer />
    </div>;
}